"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlatform = exports.arrayToString = exports.boundsToString = exports.coordinatesToString = exports.searchParams = void 0;
function searchParams(data) {
    return Object.keys(data)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]); })
        .join('&');
}
exports.searchParams = searchParams;
function coordinatesToString(coordinates, ordered) {
    if (ordered === void 0) { ordered = false; }
    if (ordered && coordinates.lat < coordinates.lng) {
        return coordinates.lng + "," + coordinates.lat;
    }
    return coordinates.lat + "," + coordinates.lng;
}
exports.coordinatesToString = coordinatesToString;
function boundsToString(bounds, ordered) {
    if (ordered === void 0) { ordered = true; }
    return coordinatesToString(bounds.southwest, ordered) + "," + coordinatesToString(bounds.northeast, ordered);
}
exports.boundsToString = boundsToString;
function arrayToString(array) {
    return array.join(',');
}
exports.arrayToString = arrayToString;
function getPlatform(platform) {
    switch (platform) {
        case 'darwin':
            return 'Mac OS X';
        case 'win32':
            return 'Windows';
        case 'linux':
            return 'Linux';
        default:
            return '';
    }
}
exports.getPlatform = getPlatform;
//# sourceMappingURL=serializer.js.map